import React from "react";
import PropTypes from "prop-types";
import clsx from "clsx";

import "./Heading.scss";

const Heading = ({ type, className, children }) => {
	switch (type) {
		case 1:
			return <h1 className={clsx("heading", `heading-${type}`, className)}>{children}</h1>;
		case 2:
			return <h2 className={clsx("heading", `heading-${type}`, className)}>{children}</h2>;
		case 3:
			return <h3 className={clsx("heading", `heading-${type}`, className)}>{children}</h3>;
		case 4:
			return <h4 className={clsx("heading", `heading-${type}`, className)}>{children}</h4>;
		case 5:
			return <h5 className={clsx("heading", `heading-${type}`, className)}>{children}</h5>;
		default:
			return <h1 className={clsx("heading", `heading-${type}`, className)}>{children}</h1>;
	}
};

Heading.propTypes = {
	type: PropTypes.number.isRequired,
	className: PropTypes.string,
	children: PropTypes.oneOfType([PropTypes.string, PropTypes.node, PropTypes.element]).isRequired,
};

Heading.defaultProps = {
	className: "",
};

export default Heading;
